import { constant } from './I18nConstants'
import { APIDirectory, HTTP } from '../rest'
import { getKeyFromLS, setDataInLS } from '../utils/LocalStorageUtil'

export const i18nMessagesFetchInProgress = () => {
  return {
    type: constant.I18N_MESSAGES_FETCH_IN_PROGRESS
  }
}

export const i18nMessagesFetchComplete = (i18nMessages) => {
  return {
    type: constant.I18N_MESSAGES_FETCH_COMPLETE,
    data: i18nMessages
  }
}

export const getI18nMessages = () => {
  return async dispatch => {
    try {
      dispatch(i18nMessagesFetchInProgress());
      let i18nMessages = await HTTP.GET(APIDirectory.geti18nMessagesURL());
      if (i18nMessages !== null) {
        setDataInLS("i18n", i18nMessages);
        dispatch(i18nMessagesFetchComplete(i18nMessages));
        return i18nMessages;
      }
    } catch (error) {
      return [];
    }
  };
}

